import React from "react";
import { Form, Input, } from 'antd';
import { Controller, } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { Info, } from "@phosphor-icons/react";

const FormFieldInputText = ({
    formName,
    formLabel,
    defaultValue = "",
    control,
    required = false,
    tooltip = undefined,
    ...props
}) => {

    const intl = useIntl();

    return (
        <FormattedMessage id={formLabel}>
            {NameField =>
                <Controller
                    control={control}
                    defaultValue={defaultValue}
                    name={formName}
                    rules={required && { required: { value: true, message: "inputfield-FieldIsRequired" } }}
                    render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { error },
                    }) => (
                        <Form.Item
                            help={required && error && intl.formatMessage({ id: error?.message || "UNKNOWN" })}
                            hasFeedback={required}
                            validateStatus={required && error?.message && "error"}
                            required={required}
                            label={<strong>{NameField}</strong>}>
                            <Input
                                ref={ref}
                                placeholder={NameField}
                                onChange={onChange}
                                value={value}
                            />
                            {tooltip && (
                                <small className="form-text text-muted">
                                    <Info size={16} weight="light" className="mx-1" /> <FormattedMessage id={tooltip} />
                                </small>
                            )}
                        </Form.Item>
                    )}
                />
            }
        </FormattedMessage>
    );
};

export default FormFieldInputText;